module.exports = __webpack_public_path__ + "img/banner-1.9a26a4de.jpg";